import { z } from 'zod';

export const fleetFormSchema = z.object({
  prefix: z.string().min(1, 'Prefixo é obrigatório'),
});

export type FleetFormSchema = z.infer<typeof fleetFormSchema>;
